import { Helmet } from 'react-helmet-async';
// sections
import { BlogListHomeView } from 'src/sections/blog/view';

// ----------------------------------------------------------------------

export default function BlogListHomePage() {
  return (
    <>
      <Helmet>
        <title> Post: List</title>
      </Helmet>

      <BlogListHomeView />
    </>
  );
}
 